import React from "react";
import { faChevronDown, faUserNurse } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Typography, useTheme } from "@mui/material";
import * as f from "../../utils/formatter";

export default function AssignedEmployee({ appointments, setChangeEmployee }) {
  const theme = useTheme();
  const employee = appointments[0]?.employee;

  return (
    <>
      <Button
        className="single-line"
        disabled={setChangeEmployee == null}
        sx={{
          color: theme.palette._components.heading.color,
          fontWeight: 400,
          fontSize: "inherit",
          padding: 0,
          borderRadius: 0,
        }}
        {...(setChangeEmployee == null
          ? {}
          : {
              onClick: (e) => {
                e.stopPropagation();

                setChangeEmployee(appointments);
              },
            })}
      >
        <FontAwesomeIcon
          icon={faUserNurse}
          size="xl"
          color={theme.palette.primary.main}
        />
        &nbsp;
        <Typography variant="caption">{f.fullName(employee)}</Typography>
        &nbsp;
        <FontAwesomeIcon icon={faChevronDown} />
      </Button>
    </>
  );
}
